import script from "./UserLocationMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLocationMarker.vue?vue&type=script&setup=true&lang=ts"

import "./UserLocationMarker.vue?vue&type=style&index=0&id=58f0b4fe&scoped=true&lang=scss"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f0b4fe"]])

export default __exports__